import {
  ArmyListSize,
  ArmyListUnit,
  ArmyListUnitOption,
  ArmyOrganisation,
  Unit,
} from '@Models';
import { computeMaxWithArmyListSize } from '@Selectors/builder/myArmyList/make/unit/new/computeMaxWithArmyListSize';

export const calculMaxSizeWithOptionModelByUnits = (
  unit: Unit,
  armyOrganisation: ArmyOrganisation,
  armyListUnitOptions: Array<ArmyListUnitOption>,
  armyListSize: ArmyListSize,
): number[] => {
  return unit.optionGroups
    .flatMap((o) => o.options)
    .filter((option) =>
      armyListUnitOptions.some((item) => item.unit_option_id === option.id),
    )
    .flatMap((option) => option.limits)
    .filter((limit) => limit.isModelByUnit)
    .filter(
      (limit) =>
        !limit.armyOrganisationId ||
        limit.armyOrganisationId === armyOrganisation.id,
    )
    .map((limit) => computeMaxWithArmyListSize(limit.max, armyListSize));
};

export const calculMaxSizeWithOptionModelByArmy = (
  unit: Unit,
  armyOrganisation: ArmyOrganisation,
  armyListUnit: ArmyListUnit,
  armyListUnits: Array<ArmyListUnit>,
  armyListSize: ArmyListSize,
): number[] => {
  // Recherche les options avec les limitations
  return unit.optionGroups
    .flatMap((o) => o.options)
    .filter((option) =>
      armyListUnit.army_list_unit_unit_options.some(
        (item) => item.unit_option_id === option.id,
      ),
    )
    .flatMap((option) => option.limits)
    .filter((limit) => limit.isModel)
    .filter(
      (limit) =>
        !limit.armyOrganisationId ||
        limit.armyOrganisationId === armyOrganisation.id,
    )
    .map((limit) => {
      const total = armyListUnits
        .filter(
          (item) =>
            item.id != armyListUnit.id && item.unit_id === armyListUnit.unit_id,
        )
        .filter((item) =>
          item.army_list_unit_unit_options.some(
            (option) => option.unit_option_id === limit.unitOptionId,
          ),
        )
        .map((item) => item.size)
        .reduce((a, b) => a + b, 0);

      return computeMaxWithArmyListSize(limit.max, armyListSize) - total;
    });
};

export const calculArmyListUnitMaxSize = (
  unit: Unit,
  armyListUnit: ArmyListUnit,
  armyOrganisation: ArmyOrganisation,
  armyListUnits: Array<ArmyListUnit>,
  armyListUnitOptions: Array<ArmyListUnitOption>,
  armyListSize: ArmyListSize,
): number => {
  const maxSizes = [
    unit.max_size,
    calculMaxSizeWithOptionModelByUnits(
      unit,
      armyOrganisation,
      armyListUnitOptions,
      armyListSize,
    ),
    calculMaxSizeWithOptionModelByArmy(
      unit,
      armyOrganisation,
      armyListUnit,
      armyListUnits,
      armyListSize,
    ),
  ].flat();

  return Math.min(...maxSizes.filter((item): item is number => !!item));
};
